
import React,{useState,useEffect} from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Breadcrumb } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';
import { PageTrafficTable, RankingTable,AllPlayers } from "../../components/Tables";
import { Row, Col, Nav, Tab } from '@themesberg/react-bootstrap';
import { faLaptopCode, faPalette } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { faCheck, faCog, faHome, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Form, Button, ButtonGroup,  InputGroup, Dropdown } from '@themesberg/react-bootstrap';
import logo from "../../components/Images/logo.jpg";
import mallvarna from "../../components/Images/mallvarna.jpg";
import Gym from "../../components/Images/Gym2.webp";
import pic1 from "../../components/Images/1.jpg";
import pic2 from "../../components/Images/2.jpg";
export default () => {


  return (
    <>
          <header className="container">
            <div className="left site__logo">
              <a href="/">
                <img src={logo} className="logo" alt="rank"/>
              </a>
            </div>
            <div className="middle">
                    <h1 className="page__title">Table Tennis Center Ranking</h1>
            </div>
            <div class="right site__logo_main">
              <a href="/" target="_blank" title="ITTF">
                <img src={mallvarna} class="logo" alt="rank2"/>
              </a>
            </div>       
          </header>
          <div id="mainContainer" className="container white"> 
          <ul className="tabs">
            <li className="active">
              <Link to="/">Начало</Link>
            </li>
            <li className="">
                <Link to="/ranking"  >Ранкинг</Link>
            </li>
          </ul>
          <div className="intro">
            <img src={Gym} className="welcome-image" alt="rank2"/>

            <div>
            <h3 className="welcome-heading">Тенис на Маса мол Варна</h3>
            <p className="welcome-paragraph">Тенис на маса ранкинг система предназначена за любителите в "Varna Moll" да бъдат част от първата за България ранкинг система. Благодарим на всички любители, които подкрепяха нашите инициативи.</p>   

          </div>
          </div>




          


          
            <RankingTable />

            
          </div>
    </>
  );
};
